import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {UpdateWorkOrderParams, WorkOrderUpdateType} from "../types/UpdateWorkOrderParams";
import {UpdateWorkOrderResult} from "../types/UpdateWorkOrderResult";


export const useUpdateWorkOrder = (
	params: UpdateWorkOrderParams,
	onSuccess: (result: UpdateWorkOrderResult) => void,
	onError: (error: string) => void) => {

	let method = '';
	let requestParams: any;
	switch (params.updateType) {
		case WorkOrderUpdateType.CustomerContact:
			method = 'submit-contact';
			requestParams = {
				workOrderID: params.wo.workOrderID,
				customerContactDate: params.wo.customerContactDate
			};
			break;
		case WorkOrderUpdateType.Schedule:
			method = 'submit-schedule';
			requestParams = {
				workOrderID: params.wo.workOrderID,
				scheduledDate: params.wo.scheduledDate,
				technicianUserID: params.wo.technicianUserID
			};
			break;
		case WorkOrderUpdateType.Complete:
			method = 'submit-work-complete';
			requestParams = {
				workOrderID: params.wo.workOrderID,
				workCompleteDate: params.wo.workCompleteDate
			};
			break;
	}

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("work-order/" + method, requestParams) as UpdateWorkOrderResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when updating the work order: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
